import { firestore } from 'firebase/app';
import { toastr } from 'react-redux-toastr';
import { reset } from 'redux-form';

const { serverTimestamp } = firestore.FieldValue;

export const sendBugReport = (payload) => {
  return async (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    const user = getState().firebase.profile;

    //console.log(payload);

    let newPayload = { ...payload };
    newPayload.sender = user.displayName;
    newPayload.date = serverTimestamp();
    newPayload.from = user.email;
    newPayload.sender_id = user.uid;
    newPayload.received_from = 'user';

    try {
      await firebase
        .push(`bugReports`, newPayload)
        .then(() => {
          dispatch(reset('contactForm'));
          toastr.success('Success', 'Bug report was sent');
        })
        .catch((error) => {
          console.error(error);
          toastr.error('Failed', 'Bug report was  not sent. ' + error.message);
        });
    } catch (error) {
      console.error(error);
      toastr.error('Failed', 'Bug report was  not sent. ' + error);
    }
  };
};
